// extracted by mini-css-extract-plugin
export default {"formSection":"src-modules-form-FormSection-style__formSection_WdAU9","grey":"src-modules-form-FormSection-style__grey_JS-p1","blue":"src-modules-form-FormSection-style__blue_QJBD0"};